<template>
  <div class="project" >

    <nav class="navbar is-mobile is-medium" style="background-color: #30008A;" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
          <img id="navbar-logo" src="../../assets/projects/charette/kea19.png" alt="Solid Logo">
      </div>
    </nav>

      <h1 class="title "> KEA Charette (2019) in Copenhagen </h1>

      <p>Participating in the KEA Charette event held in Copenhagen presented an intriguing challenge:
        crafting a fresh and captivating visual identity for a government-funded cultural music program. My
        objective was to design an identity that resonated deeply with Denmark’s youth demographic. Collab-
        orating with fellow students from diverse global backgrounds, we formed dynamic groups to tackle
        this challenge collectively. This collaborative approach allowed for a rich exchange of ideas, leading
        to the creation of a visual identity that not only encapsulated the program’s essence but also spoke
        directly to the target audience, fostering a sense of connection and engagement.</p>
     <br>
      <div class="photo-grid">
    <div class="columns is-multiline">
      <div class="column is-one-third">
        <figure class="image">
          <img src="../../assets/projects/charette/newbrand6.png" alt="Image 1">
        </figure>
      </div>
      <div class="column is-one-third">
        <figure class="image">
          <img src="../../assets/projects/charette/newbrand4.png" alt="Image 3">
        </figure>
      </div>
      <div class="column is-one-third">
        <figure class="image">
          <img src="../../assets/projects/charette/newbrand5.png" alt="Image 2">
        </figure>
      </div>
      <div class="column is-one-third">
        <figure class="image">
          <img src="../../assets/projects/charette/newbrand1.png" alt="Image 4">
        </figure>
      </div>
      <div class="column is-one-third">
        <figure class="image">
          <img src="../../assets/projects/charette/newbrand3.png" alt="Image 5">
        </figure>
      </div>
      <div class="column is-one-third">
        <figure class="image">
          <img src="../../assets/projects/charette/newbrand2.png" alt="Image 6">
        </figure>
      </div>
    </div>
  </div>
  <br><br>
        <video src="../../assets/projects/charette/KeaCharetteWebsite.mp4" muted controls autoplay @loadedmetadata="skipVideo"></video>

        <br> <br>
        <img src="../../assets/projects/charette/page.png" alt="">
        <br>
  </div>
</template>

<script>
export default {
  methods: {
    skipVideo(event) {
      // Skip the first 2 seconds
      event.target.currentTime = 2;
    }
  }
}
</script>

<style scoped>
  
@import 'project.css';

</style>